module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"cancel":"取消"}}')
  delete Component.options._Ctor
}
